module.exports = __webpack_public_path__ + "static/media/background.9202d8c9.jpg";